import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTickinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 2,
		d: "M4 13.72L9.926 19 20 4",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgTickinline;
